import React from 'react'
import { ReactComponent as Icon } from '../../icons/legend.svg'
import styled, { css } from 'styled-components'
import { Ls, CableEnd } from '../../style'

const LegendIcon = styled(Icon)`
  position: fixed;
  bottom: 1rem;
  right: 0.5rem;
  width: 48px;
  height: 48px;
  cursor: pointer;
  z-index: 12;
  -webkit-filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.2));
  filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.2));
`

const Card = styled.div`
  position: fixed;
  bottom: 5rem;
  right: 0.5rem;
  background: #fff;
  width: 240px;
  padding: 0px;
  text-align: left;
  border-radius: 1rem;
  box-shadow: 0px 6px 18px rgba(0, 0, 0, 0.2);
  z-index: 13;
  pointer-events: none;
  ${props =>
    !props.mobile &&
    css`
      bottom: 1rem;
      right: 1rem;
    `};
`
const Content = styled.div`
  padding: 1rem;
`

const Element = styled.div`
  height: 24px;
  margin-right: 16px;
  min-width: calc(50vw-24px);
  width: 100%;
  float: none;
  clear: both;
`

const Desc = styled.div`
  line-height: 24px;
  float: left;
`

const LIcon = styled.svg`
  line-height: 24px;
  width: 24px;
  height: 24px;
  float: left;
`

const LIconPop = styled.svg`
  line-height: 24px;
  width: 24px;
  height: 24px;
  float: left;
  stroke-width: 2px;
  stroke: ${props =>
    props.layer === 'network'
      ? 'orange'
      : props.layer === 'ip'
      ? 'rgb(255, 200, 90)'
      : props.layer === 'capacity'
      ? '#0097ad'
      : props.layer === 'colocation' && 'rgb(150, 54, 139)'};
  fill: none;
`

const LIconFibre = styled.line`
  stroke-width: 2px;
  stroke: #ffc85a;
  fill: none;
`

const LIconFibreExt = styled.line`
  stroke-width: 0.5px;
  stroke: #000;
  fill: none;
`

const Clear = styled.div`
  height: 2px;
  width: 100%;
  clear: both;
`

const LPoP = ({ layer }) => {
  return (
    <Element>
      <LIconPop layer={layer}>
        <circle r="6" cx="12" cy="12" />
      </LIconPop>
      <Desc>Telxius PoP</Desc>
    </Element>
  )
}

const LLS = ({ layer }) => {
  return (
    <>
      <Element>
        <LIcon>
          <Ls layer={layer} telxius={true} selected={false} key={`lls`} width="12" height="12" x="6" y="6" />
        </LIcon>

        <Desc>Telxius Landing Station</Desc>
      </Element>
      <Element>
        <LIcon>
          <Ls layer={layer} telxius={false} selected={false} key={`lls`} width="8" height="8" x="8" y="8" />
        </LIcon>
        <Desc>Off-Net Landing Station</Desc>
      </Element>
    </>
  )
}
const CEnd = () => {
  return (
    <Element>
      <LIcon>
        <CableEnd key={`cend`} width="6" height="6" x="9" y="9" />
      </LIcon>
      <Desc>Landing Station</Desc>
    </Element>
  )
}

const LFibre = () => {
  return (
    <Element>
      <LIcon>
        <LIconFibre x1="6" y1="12" x2="18" y2="12" />
      </LIcon>
      <Desc>Terrestrial backhaul</Desc>
    </Element>
  )
}
const LFibreExt = () => {
  return (
    <Element>
      <LIcon>
        <LIconFibreExt x1="6" y1="12" x2="18" y2="12" />
      </LIcon>
      <Desc>Extended fibre route</Desc>
    </Element>
  )
}

const LegendCard = ({ layer, mobile }) => {
  return (
    <Card mobile={mobile}>
      <Content>
        {layer === 'network' ? (
          <>
            <LPoP layer={layer} />
            <LLS layer={layer} />
            <LFibre />
            <LFibreExt />
          </>
        ) : layer === 'cables' ? (
          <>
            <LLS layer={layer} />
          </>
        ) : layer === 'ip' ? (
          <>
            <LPoP layer={layer} />
            <LFibre />
          </>
        ) : layer === 'capacity' ? (
          <>
            <LPoP layer={layer} />
            <CEnd />
          </>
        ) : layer === 'colocation' ? (
          <>
            <LPoP layer={layer} />
          </>
        ) : (
          ''
        )}
        <Clear />
      </Content>
    </Card>
  )
}

const Legend = ({ layer, mobile, show, toggle }) => {
  return !mobile ? (
    <LegendCard layer={layer} mobile={mobile} />
  ) : show ? (
    <>
      <LegendCard layer={layer} mobile={mobile} />
      <LegendIcon onClick={toggle} />
    </>
  ) : (
    <LegendIcon onClick={toggle} />
  )
}

export default Legend
